module.exports = __webpack_public_path__ + "img/ch.26f97a34.svg";